import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NavController, NavParams, Platform } from "ionic-angular";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Order } from "../../models/order";
import { OrdenProvider } from "../../providers/orden/orden";
import { SocialSharing } from "@ionic-native/social-sharing";
import { API_URL, SHARE_URL } from "../../constants";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: "page-detalle-orden",
  templateUrl: "detalle-orden.html",
})
export class DetalleOrdenPage {
  orden: Order;

  constructor(
    public navCtrl: NavController,
    private orderProvider: OrdenProvider,
    private socialSharing: SocialSharing,
    public navParams: NavParams,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    let id = this.navParams.get("id");

    this.orderProvider.getOrder(id).subscribe(
      (res: Order) => {
        this.orden = res;
      },
      (err) => {
        console.log(`Error en obtener la orden`, err);
      }
    );
  }

  shareWhatsApp() {
    this.socialSharing
      .shareViaWhatsApp(
        `Esta es tu cotización`,
        null,
        `${SHARE_URL}share/orden/${this.orden.uuid}`
      )
      .then(() => {
        // Success
        console.log("compartido");
      })
      .catch((e) => {
        // Error!
      });
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(
      `whatsapp://send?text=Esta es tu cotización: ${SHARE_URL}share/orden/${this.orden.uuid}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/detalle-orden/detalle-orden.ts